import { RouteObject } from '@rocketlane/rocket-router';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { ResourceManagementPage } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

export const resourceManagementRoutes: RouteObject = {
  path: `${ROUTE_PATHS.RESOURCE_MANAGEMENT}/*`,
  element: (
    <SecureRoute rule="RESOURCE_MANAGEMENT:READ">
      <ResourceManagementPage />
    </SecureRoute>
  ),
  // async lazy() {
  //   const { ResourceManagementRoute } = await retryImportInsideRoutesDefinition(
  //     () => import('.'),
  //   );

  //   return {
  //     element: (
  //       <SecureRoute rule="RESOURCE_MANAGEMENT:READ">
  //         <ResourceManagementRoute />
  //       </SecureRoute>
  //     ),
  //   };
  // },
};
